import { render, staticRenderFns } from "./EquipmentInfo.vue?vue&type=template&id=6ac0ed74&"
import script from "./EquipmentInfo.vue?vue&type=script&lang=js&"
export * from "./EquipmentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VIcon,VListItem,VListItemContent,VListItemSubtitle})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ac0ed74')) {
      api.createRecord('6ac0ed74', component.options)
    } else {
      api.reload('6ac0ed74', component.options)
    }
    module.hot.accept("./EquipmentInfo.vue?vue&type=template&id=6ac0ed74&", function () {
      api.rerender('6ac0ed74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/equipment/components/EquipmentInfo.vue"
export default component.exports